const getInitialState = () => ({
    openRequests: [],
    failedRequests: [],
    updatedAt: 0,
    documents: {
        entries: {},
        maxCount: 0,
    },
    lastInteractiveGuid: null,
});

export default {
    getInitialState
};
